"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given number is less than or equal to the threshold value.
 *
 * @export
 * @class IsLessThanOrEqualToValidator
 * @implements {PropertyValidator<number>}
 */
class IsLessThanOrEqualToValidator {
    constructor(threshold) {
        this.threshold = threshold;
    }
    isValid(input) {
        if (typeof input === "undefined" || input === null) {
            return false;
        }
        return input <= this.threshold;
    }
}
exports.IsLessThanOrEqualToValidator = IsLessThanOrEqualToValidator;
//# sourceMappingURL=IsLessThanOrEqualToValidator.js.map